import { type DashRouteType, URL_APP_ADMIN, URL_RETAILER_SCOPED } from 'utils/routing/routes'

// Retailer Merchandising Collection Routes
const URL_RETAILER_COLLECTIONS = `${URL_RETAILER_SCOPED}/collections`
const URL_RETAILER_COLLECTIONS_LIST = `${URL_RETAILER_SCOPED}/collections/list`
const URL_RETAILER_COLLECTIONS_SHOW = `${URL_RETAILER_SCOPED}/collections/show/:collectionId`
const URL_RETAILER_COLLECTIONS_NEW = `${URL_RETAILER_SCOPED}/collections/new`
const URL_RETAILER_COLLECTIONS_EDIT = `${URL_RETAILER_SCOPED}/collections/edit/:collectionId`

// Retailer Navigation Collection Routes
const URL_RETAILER_NAV_COLLECTIONS = `${URL_RETAILER_SCOPED}/nav-collections`
const URL_RETAILER_NAV_COLLECTIONS_LIST = `${URL_RETAILER_SCOPED}/nav-collections/list`
const URL_RETAILER_NAV_COLLECTIONS_SHOW = `${URL_RETAILER_SCOPED}/nav-collections/show/:collectionId`
const URL_RETAILER_NAV_COLLECTIONS_NEW = `${URL_RETAILER_SCOPED}/nav-collections/new`
const URL_RETAILER_NAV_COLLECTIONS_EDIT = `${URL_RETAILER_SCOPED}/nav-collections/edit/:collectionId`

// Internal Merchandising Collections Routes
const URL_APP_ADMIN_COLLECTIONS = `${URL_APP_ADMIN}/collections`
const URL_APP_ADMIN_COLLECTIONS_LIST = `${URL_APP_ADMIN}/collections/list`
const URL_APP_ADMIN_COLLECTIONS_SHOW = `${URL_APP_ADMIN}/collections/show/:collectionId`
const URL_APP_ADMIN_COLLECTIONS_NEW = `${URL_APP_ADMIN}/collections/new`
const URL_APP_ADMIN_COLLECTIONS_EDIT = `${URL_APP_ADMIN}/collections/edit/:collectionId`

// Internal Navigation Collections Routes
const URL_APP_ADMIN_NAV_COLLECTIONS = `${URL_APP_ADMIN}/nav-collections`
const URL_APP_ADMIN_NAV_COLLECTIONS_LIST = `${URL_APP_ADMIN}/nav-collections/list`
const URL_APP_ADMIN_NAV_COLLECTIONS_SHOW = `${URL_APP_ADMIN}/nav-collections/show/:collectionId`
const URL_APP_ADMIN_NAV_COLLECTIONS_NEW = `${URL_APP_ADMIN}/nav-collections/new`
const URL_APP_ADMIN_NAV_COLLECTIONS_EDIT = `${URL_APP_ADMIN}/nav-collections/edit/:collectionId`

export type DashRouteSet =
  | DashRouteType<'app-admin-collections'>
  | DashRouteType<'app-admin-collections-list'>
  | DashRouteType<'app-admin-collections-show', { collectionId: string }>
  | DashRouteType<'app-admin-collections-new'>
  | DashRouteType<'app-admin-collections-edit', { collectionId: string }>
  | DashRouteType<'legacy-retailer-collections'>
  | DashRouteType<'legacy-retailer-collections-list'>
  | DashRouteType<'legacy-retailer-collections-show', { collectionId: string }>
  | DashRouteType<'legacy-retailer-collections-new'>
  | DashRouteType<'legacy-retailer-collections-edit', { collectionId: string }>
  | DashRouteType<'app-admin-nav-collections'>
  | DashRouteType<'app-admin-nav-collections-list'>
  | DashRouteType<'app-admin-nav-collections-show', { collectionId: string }>
  | DashRouteType<'app-admin-nav-collections-new'>
  | DashRouteType<'app-admin-nav-collections-edit', { collectionId: string }>
  | DashRouteType<'retailer-nav-collections'>
  | DashRouteType<'retailer-nav-collections-list'>
  | DashRouteType<'retailer-nav-collections-show', { collectionId: string }>
  | DashRouteType<'retailer-nav-collections-new'>
  | DashRouteType<'retailer-nav-collections-edit', { collectionId: string }>

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-collections': URL_APP_ADMIN_COLLECTIONS,
  'app-admin-collections-list': URL_APP_ADMIN_COLLECTIONS_LIST,
  'app-admin-collections-show': URL_APP_ADMIN_COLLECTIONS_SHOW,
  'app-admin-collections-new': URL_APP_ADMIN_COLLECTIONS_NEW,
  'app-admin-collections-edit': URL_APP_ADMIN_COLLECTIONS_EDIT,
  'legacy-retailer-collections': URL_RETAILER_COLLECTIONS,
  'legacy-retailer-collections-list': URL_RETAILER_COLLECTIONS_LIST,
  'legacy-retailer-collections-show': URL_RETAILER_COLLECTIONS_SHOW,
  'legacy-retailer-collections-new': URL_RETAILER_COLLECTIONS_NEW,
  'legacy-retailer-collections-edit': URL_RETAILER_COLLECTIONS_EDIT,
  'app-admin-nav-collections': URL_APP_ADMIN_NAV_COLLECTIONS,
  'app-admin-nav-collections-list': URL_APP_ADMIN_NAV_COLLECTIONS_LIST,
  'app-admin-nav-collections-show': URL_APP_ADMIN_NAV_COLLECTIONS_SHOW,
  'app-admin-nav-collections-new': URL_APP_ADMIN_NAV_COLLECTIONS_NEW,
  'app-admin-nav-collections-edit': URL_APP_ADMIN_NAV_COLLECTIONS_EDIT,
  'retailer-nav-collections': URL_RETAILER_NAV_COLLECTIONS,
  'retailer-nav-collections-list': URL_RETAILER_NAV_COLLECTIONS_LIST,
  'retailer-nav-collections-show': URL_RETAILER_NAV_COLLECTIONS_SHOW,
  'retailer-nav-collections-new': URL_RETAILER_NAV_COLLECTIONS_NEW,
  'retailer-nav-collections-edit': URL_RETAILER_NAV_COLLECTIONS_EDIT,
}

export type DomainRouteName = keyof typeof routes
